export class InscriptionsConstants {
    public static OpenStatuses = {
        OPEN: "OPEN",
        FUTURE: "FUTURE",
        PAST: "PAST",
    };
    public static RecurrencesTypes = {
        OneTime: "OneTime",
        Monthly: "Monthly",
        Quarterly: "Quarterly",
        Yearly: "Yearly"
    };
    /** Les Franqueses del Vallès (WT-7336): hide the in-person inscription CTA. */
    public static HideAttendedButtonInscriptionIds: readonly number[] = [1157];
  }
